import React from 'react';

const VARIATIONS = [
  {
    bgColor: 'bg-cloud',
    textColor: 'text-black',
    borderColor: 'border-cloudTertiary',
  },
  {
    bgColor: 'bg-yellow',
    textColor: 'text-black',
    borderColor: 'border-gold',
  },
  {
    bgColor: 'bg-dusk-light',
    textColor: 'text-black',
    borderColor: 'border-dusklightTertiary',
  },
  {
    bgColor: 'bg-midnight',
    textColor: 'text-white',
    borderColor: 'border-midnightTertiary',
  },
];

function getRandomVariation() {
  return VARIATIONS[Math.floor(Math.random() * VARIATIONS.length)];
}

export function Tip({ tipText }) {
  const { bgColor, textColor, borderColor } = getRandomVariation();

  return (
    <div
      className={`${bgColor} ${textColor} ${borderColor} border-l-[10px] p-5 rounded-[8px] my-6`}
    >
      <span className="font-bold">Important:</span>
      <span dangerouslySetInnerHTML={{ __html: tipText }} />
    </div>
  );
}
